module.exports = __webpack_public_path__ + "static/media/track-suavemente.27d617cf.png";